import { TableRow as MuiTableRow, styled, tableCellClasses } from '@mui/material';
import { shouldNotForwardProps } from '../../helpers';
export const TableRowStyled = styled(MuiTableRow, shouldNotForwardProps('isGroupHeader', 'hidden', 'verticalAlign'))(({ theme, isGroupHeader, hidden, verticalAlign }) => ({
    ...(isGroupHeader && {
        [`.${tableCellClasses.root}`]: {
            backgroundColor: theme.palette.background.light,
        },
    }),
    ...(hidden && {
        display: 'none',
    }),
    ...(verticalAlign && {
        verticalAlign,
    }),
}));
